import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { User } from '../_models/user';
import { UserService } from '../_services/user.service';
import { Permissions } from '../_models/permissions';
import { environment } from '../../environments/environment';
declare let ga: Function;

enum Claims {
    CAN_SEE_ALL_ORGS = 1,
    CAN_MANAGE_USERS = 2,
    CAN_SEE_DISABLED_USERS = 4,
    CAN_SEE_AIDS_FUND_ROLES = 8,
    CAN_SEE_OTHER_USERS_APPS = 16,
    CAN_PROCESS_APPS = 32, 
    CAN_CHANGE_DISPOSITION_APPS = 64,
    CAN_SEE_DRAFTS = 128
}

@Injectable()
export class AuthenticationService {

    public currentUser: User;
    public permissions: Permissions;

    constructor(
      private http: Http,
      private userService: UserService) { }

    
    clearUserData() {
      this.currentUser = null;
      this.permissions = null;
      localStorage.setItem('currentUser', null);
      return false;
    }

    private setPermissions(user: User) {
        var userPermissions = parseInt(user.permissions);
        if(!this.permissions) { this.permissions = new Permissions }
        this.permissions.canManagerUsers = !!(userPermissions & Claims.CAN_MANAGE_USERS);
        this.permissions.canDraftApplications = !!(userPermissions & Claims.CAN_SEE_DRAFTS);
        this.permissions.canProcessApplications = !!(userPermissions & Claims.CAN_PROCESS_APPS);
        this.permissions.canChangeDispositionApplications = !!(userPermissions & Claims.CAN_CHANGE_DISPOSITION_APPS);
        this.permissions.canSeeAllOrganizations = !!(userPermissions & Claims.CAN_SEE_ALL_ORGS);
        
    }

    isValidSession(): Promise<Boolean> {
      if (this.currentUser) {
        return Promise.resolve(true);
      } else if (!!localStorage.getItem('currentUser') && localStorage.getItem('currentUser') !== 'null') {
        let id = JSON.parse(localStorage.getItem('currentUser')).id;

        return this.userService.getUser(id)
          .then((user: User) => {
            this.currentUser = user;
            this.setPermissions(this.currentUser);
            return true;
          })
          .catch(this.clearUserData.bind(this));
      } else {
        return Promise.reject(false);
      }
    }

    login(username: string, password: string) {
      let url = environment.apiUrl + 'users/login';
      let body = JSON.stringify({ username: username, password: password });

      return this.http.post(url, body)
              .toPromise()
              .then((response: Response) => {
                  if (response.status === 201) {
                    this.currentUser = <User> response.json();
                    this.setPermissions(this.currentUser);
                    localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
                    ga('send', 'event', 'Users', 'Login', this.currentUser.organization, this.currentUser.organization_id);
                    return response.json();
                  } else {
                    this.clearUserData();
                    throw response.json().error;
                  }
              })
              .catch(err => {
                  this.clearUserData();
                  throw err;
              });
    }

    logout() {
      let url = environment.apiUrl + 'users/logout';
      let body = '';

      return this.http.post(url, body)
              .toPromise()
              .then((response: Response) => {
                  ga('send', 'event', 'Users', 'Logout', this.currentUser.organization, this.currentUser.organization_id);
                  this.clearUserData();
                  if (response.status !== 200) {
                    throw response.json().error;
                  }
              })
              .catch(err => {
                  this.clearUserData();
                  throw err;
              });
    }
}




// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts